import { Box, SxProps } from '@mui/material';

import { COLORS } from '~/styles/colors';

type VCardPreviewSummaryProps = {
  summary: string;
  rounded?: boolean;
  sx?: SxProps;
  isMarginHorizontal?: boolean;
  isAnonymous?: boolean;
};

export default function VCardPreviewSummary({
  summary,
  rounded = true,
  sx = {},
  isMarginHorizontal = false,
  isAnonymous = false,
}: VCardPreviewSummaryProps) {
  let margin: string | undefined;

  if (isMarginHorizontal) {
    margin = '0 2px';
  }

  if (isAnonymous) {
    margin = '0 5px';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '10px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundColor: isAnonymous ? undefined : COLORS.white,
        borderRadius: rounded ? '12px' : undefined,
        margin,
        ...sx,
      }}
    >
      <Box
        dangerouslySetInnerHTML={{ __html: summary }}
        sx={{ color: COLORS.black08, wordBreak: 'break-word', fontSize: '9px', textAlign: 'center', width: '100%' }}
      />
    </Box>
  );
}
